import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "w-4 h-4",
  width: "24",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = ["href"]
const _hoisted_3 = {
  key: 1,
  class: "absolute -translate-y-1/2 top-2/4 right-4"
}

import { ref } from 'vue';
export type ActionButtonProps = {
    label: string, // display text
    icon: string, // action to perform
    styleType: string, // display style
    spinner: boolean, // show spinner
    onclick: () => void | boolean, // callback
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ActionButtonComponent',
  props: {
    label: {},
    icon: {},
    styleType: {},
    spinner: { type: Boolean },
    onclick: { type: Function }
  },
  setup(__props: any) {

const props = __props

const clicked = ref(false)

let classList: string[] = []
if (props.styleType === "white"){
    classList = ["cursor-pointer", "font-bold", "text-center", "btn", "rounded-2.4xl", "xl:rounded-3xl", "text-mono-ns-200", "bg-mono-white", "hover:bg-mono-ps-100", "min-w-fit", "w-full", "relative"]
}else if (props.styleType === "primary"){
    classList = ["cursor-pointer", "font-bold", "text-center", "btn", "cta-g", "rounded-2.4xl", "xl:rounded-3xl", "text-mono-white", "min-w-fit", "w-full"]
}else if (props.styleType === "optional"){
    classList = ["cursor-pointer", "font-bold", "text-center", "btn", "rounded-2.4xl", "xl:rounded-3xl", "text-mono-white", "bg-mono-ns-200", "hover:bg-mono-ns-300", "min-w-fit", "w-full", "relative"]
}

if (props.icon){
    classList = classList.concat(['flex', 'flex-row', 'items-center', 'justify-center', 'gap-1'])
}

function clickHandler() {
    if (props.onclick){
        const result = props.onclick()
        if (result !== undefined){
            clicked.value = result
        }
    }else{
        clicked.value = true;
    }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass(_unref(classList)),
    onClick: clickHandler
  }, [
    (props.icon)
      ? (_openBlock(), _createElementBlock("svg", _hoisted_1, [
          _createElementVNode("use", {
            href: '#' + props.icon
          }, null, 8, _hoisted_2)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("span", null, _toDisplayString(props.label), 1),
    (clicked.value && props.spinner)
      ? (_openBlock(), _createElementBlock("span", _hoisted_3, _cache[0] || (_cache[0] = [
          _createElementVNode("span", { class: "block border-mono-ns-200 h-4 w-4 animate-spin rounded-full border-4 border-t-mono-white" }, null, -1)
        ])))
      : _createCommentVNode("", true)
  ], 2))
}
}

})